export const Default = {
    light: {
        primary: '#4351dd',
        secondary: '#3f51b5',
        black: 'rgba(0,0,0,0.65)',
        inputColor: 'rgba(0,0,0,0.65)',
        background: {
            default: '#f6f8fc',
            secondary: '#f9f9fa'
        },
        divider: 'rgba(0,0,0,0.08)',
    },
    dark: {
        primary: '#4351dd',
        secondary: '#3f51b5',
        black: 'rgba(255,255,255,0.57)',
        inputColor: 'rgba(0,0,0,0.65)',
        divider: 'rgba(255,255,255,0.08)',
    }
}

export const Pink = {
    light: {
        primary: '#e91e63',
        secondary: '#9c27b0',
        black: 'rgba(0,0,0,0.65)',
        inputColor: 'rgba(0,0,0,0.65)',
        background: {
            default: '#fff0f3',
            secondary: '#ffccd5'
        },
        divider: 'rgba(255,0,87,0.24)',
    },
    dark: {
        primary: '#e91e63',
        secondary: '#9c27b0',
        black: 'rgba(255,255,255,0.57)',
        inputColor: 'rgba(0,0,0,0.65)',
        divider: 'rgba(255,255,255,0.08)',
    }
}

export const Green = {
    light: {
        primary: '#4caf50',
        secondary: '#8bc34a',
        black: 'rgba(0,0,0,0.65)',
        inputColor: 'rgba(0,0,0,0.65)',
        background: {
            default: '#f1f8e9',
            secondary: '#dcedc8'
        },
        divider: 'rgba(0,0,0,0.08)',
    },
    dark: {
        primary: '#4caf50',
        secondary: '#8bc34a',
        black: 'rgba(255,255,255,0.57)',
        inputColor: 'rgba(0,0,0,0.65)',
        divider: 'rgba(255,255,255,0.08)',
    }
}

export const Blue = {
    light: {
        primary: '#2196f3',
        secondary: '#03a9f4',
        black: 'rgba(0,0,0,0.65)',
        inputColor: 'rgba(0,0,0,0.65)',
        background: {
            default: '#e3f2fd',
            secondary: '#bbdefb'
        },
        divider: 'rgba(0,0,0,0.08)',
    },
    dark: {
        primary: '#2196f3',
        secondary: '#03a9f4',
        black: 'rgba(255,255,255,0.57)',
        inputColor: 'rgba(0,0,0,0.65)',
        divider: 'rgba(255,255,255,0.08)',
    }
}

// purple

export const Purple = {
    light: {
        primary: '#9c27b0',
        secondary: '#673ab7',
        black: 'rgba(0,0,0,0.65)',
        inputColor: 'rgba(0,0,0,0.65)',
        background: {
            default: '#f3e5f5',
            secondary: '#e1bee7'
        },
        divider: 'rgba(0,0,0,0.08)',
    },
    dark: {
        primary: '#9c27b0',
        secondary: '#673ab7',
        black: 'rgba(255,255,255,0.57)',
        inputColor: 'rgba(0,0,0,0.65)',
        divider: 'rgba(255,255,255,0.08)',
    }
}

// fuchsia

export const Fuchsia = {
    light: {
        primary: '#86198f',
        secondary: '#7c4dff',
        black: 'rgba(0,0,0,0.65)',
        inputColor: 'rgba(0,0,0,0.65)',
        background: {
            default: '#f3e5f5',
            secondary: '#e1bee7'
        },
        divider: 'rgba(0,0,0,0.08)',
    },
    dark: {
        primary: '#e040fb',
        secondary: '#7c4dff',
        black: 'rgba(255,255,255,0.57)',
        inputColor: 'rgba(0,0,0,0.65)',
        divider: 'rgba(255,255,255,0.08)',
    }
}

export const availablePalettes = [
    {
        id: 'default',
        name: 'Энгийн',
        colors: Default
    },
    {
        id: 'pink',
        name: 'Ягаан',
        colors: Pink
    },
    {
        id: 'green',
        name: 'Ногоон',
        colors: Green
    },
    {
        id: 'blue',
        name: 'Цэнхэр',
        colors: Blue
    },
    {
        id: 'purple',
        name: 'Чирнээлийн ягаан',
        colors: Purple
    },
    {
        id: 'fuchsia',
        name: 'ЭН БИ СИ Өнгө',
        colors: Fuchsia
    }
]
